import { useEffect } from "react"

import { fetchEvents } from "../../api/events.api"
import { setNavBadge } from "../../shell/nav-badges"

/**
 * Счётчик дел для колокольчика и для пункта меню.
 *
 * ЗАЧЕМ ОТДЕЛЬНО ОТ ЭКРАНА. Колокольчик стоит в шапке всегда, а лента открыта минуту
 * в день: счётчик, живущий только внутри экрана, показывал бы число ровно тому, кто
 * и без него уже смотрит на список. Поэтому число спрашивает оболочка — одним запросом
 * на страницу событий, где сервер и так считает его для ленты.
 *
 * РАЗ В ПЯТЬ МИНУТ, А НЕ РАЗ В МИНУТУ. Дела в центре появляются от действий КЛИЕНТОВ:
 * онлайн-запись и онлайн-отмена — события редкие даже в большом салоне. Минутный опрос
 * дал бы шестьдесят запросов в час с каждой открытой вкладки за стойкой, и ради чего:
 * администратор всё равно узнаёт о деле не в ту секунду, когда оно возникло, а когда
 * поднимет глаза. Пять минут — то, что в ТЗ §4.6 названо «данные на 13:47»: честная
 * свежесть вместо дорогой иллюзии мгновенности.
 *
 * ОШИБКА МОЛЧИТ. Счётчик — это украшение шапки, а не содержание экрана: отказ сети
 * не должен рисовать человеку экран сбоя поверх журнала, в котором он работает. Число
 * просто остаётся прежним, а свежесть данных кабинет показывает своей полосой.
 */
const EVERY_MS = 5 * 60 * 1000

export function useEventsBadge(branchId: string | undefined): void {
  useEffect(() => {
    let cancelled = false
    const controller = new AbortController()

    const read = async (): Promise<void> => {
      try {
        const page = await fetchEvents(
          { onlyAction: true, limit: 1, ...(branchId === undefined ? {} : { branchId }) },
          controller.signal,
        )
        if (!cancelled) setNavBadge("notifications", page.actionRequired)
      } catch {
        // Молчим намеренно — см. шапку файла.
      }
    }

    void read()
    const timer = setInterval(() => void read(), EVERY_MS)
    return () => {
      cancelled = true
      controller.abort()
      clearInterval(timer)
    }
  }, [branchId])
}
